import { Document, Page, View, Text, Image, Font } from "@react-pdf/renderer";
import actaStyles from "./actaStyles";
import logoArt from "./assets/logo-art.jpg";
import bannerPie from "./assets/banner-pie.jpg";

// Sin esto react-pdf parte las palabras con reglas de inglés ("ALI-MENTACIÓN").
Font.registerHyphenationCallback((word) => [word]);

// ---------------------------------------------------------------------------
// Textos propios del formato del acta (no vienen del formulario)
// ---------------------------------------------------------------------------
export const CONVENIO = "FCP 866 2023 - UTF/COL/160/COL";

const NOMBRE_CONVENIO =
  "IMPLEMENTAR ACTIVIDADES DE DESARROLLO ECONÓMICO, DERECHO HUMANO A LA ALIMENTACIÓN Y FORTALECIMIENTO DE CAPACIDADES INSTITUCIONALES, COMUNITARIAS Y ORGANIZACIONALES";

const TITULO_BIENES =
  "BIENES (Equipos, herramientas, insumos, materiales, otros: garantías, manuales de uso y mantenimiento)";

const INTRO_FAO =
  `La Organización de las Naciones Unidas para la Alimentación y la Agricultura – FAO, en el marco del convenio ${CONVENIO}, suscrito con la Agencia de Renovación del Territorio – ART, hace entrega`;

const CLAUSULAS_COMUNES = [
  "Los bienes recibidos serán de uso exclusivo y para los fines, propósitos y necesidades que se pretenden satisfacer con la ejecución del proyecto de la referencia, el cual fue concebido para obtener un beneficio tangible para la comunidad.",
  "Ningún particular podrá apropiarse de los bienes recibidos, por tener un uso, destinación y finalidad específica trazada en el mismo.",
  "Está prohibida la venta o cualquier forma de comercialización de los bienes recibidos, por cuanto estos buscan satisfacer las necesidades identificadas en la formulación del proyecto, salvo disposición contraria contemplada dentro del proyecto.",
  "Se compromete, acepta y entiende, las implicaciones de la administración e incluso las responsabilidades tributarias que se desprenden de la recepción de los bienes entregados. (FAO mediante capacitaciones socializó y dio a conocer, los cambios, ventajas, desventajas y activación de ruta de garantías para los diferentes bienes)"
];

const CLAUSULAS_INDIVIDUAL = [
  ...CLAUSULAS_COMUNES,
  "Se compromete a darle buen uso al bien transferido y, en especial, a no usarlo(s) para ningún fin ilícito.",
  "Se compromete a vincular y controlar tanto a sus activos como su partida patrimonial de los activos productivos entregados con el fin de mantener en el tiempo, su sostenibilidad financiera como existencia de estos.",
  "Los bienes entregados deben ser reconocidos en la contabilidad de la organización."
];

const CLAUSULAS_ORGANIZACION = [
  ...CLAUSULAS_COMUNES,
  "Se compromete a darle buen uso al bien entregado y, en especial, a no usarlo(s) para ningún fin ilícito.",
  "Se compromete a vincular y controlar tanto a sus activos como su partida patrimonial de los activos productivos transferidos con el fin de mantener en el tiempo, su sostenibilidad financiera como existencia de estos.",
  "Los bienes entregados deben ser reconocidos en la contabilidad de la organización."
];

const SEGUIMIENTO =
  "La FAO, la ART y/o los entes de control, podrán realizar seguimiento al buen uso de los bienes transferidos, y en desarrollo de esas funciones podrá realizar visitas de verificación de los bienes en los lugares en donde ellos deben disponerse, así como solicitar los reportes que considere pertinentes para verificar su buen uso.";

const EXIMENTE =
  "exime a la FAO de cualquier responsabilidad originada en el bien transferido. Una vez firmada esta acta, la FAO quedará exenta de cualquier reclamación originada en el bien entregado. En ese sentido, la FAO no estará obligada a hacer reparaciones, pagar indemnizaciones, sanear daños, cubrir afectaciones a la organización productiva beneficiaria o a terceros, pagar impuestos, tasas o multas de tránsito, ni ninguna otra acción originada en el bien objeto de esta";

const LINEA = "________________";

const InfoRow = ({ label, value, last }) => (
  <View style={last ? actaStyles.infoRowLast : actaStyles.infoRow} wrap={false}>
    <Text style={actaStyles.infoLabel}>{label}</Text>
    <Text style={actaStyles.infoValue}>{value || ""}</Text>
  </View>
);

const TipoEntregaRow = ({ tipoActa }) => (
  <View style={actaStyles.infoRow} wrap={false}>
    <Text style={actaStyles.infoLabel}>Tipo de entrega</Text>
    <View style={actaStyles.tipoEntregaValue}>
      <Text style={actaStyles.tipoEntregaTexto}>Parcial</Text>
      <Text style={actaStyles.tipoEntregaCaja}>{tipoActa === "Final" ? "" : "X"}</Text>
      <Text style={actaStyles.tipoEntregaTexto}>Final</Text>
      <Text style={actaStyles.tipoEntregaCaja}>{tipoActa === "Final" ? "X" : ""}</Text>
    </View>
  </View>
);

const TablaBienes = ({ bienes }) => (
  <View style={actaStyles.bienesTable}>
    <View wrap={false}>
      <Text style={actaStyles.bienesTitulo}>{TITULO_BIENES}</Text>
      <View style={actaStyles.bienesHeaderRow}>
        <Text style={[actaStyles.bienesCellNo, actaStyles.bienesHeaderText]}>No. Ítem</Text>
        <Text style={[actaStyles.bienesCellBien, actaStyles.bienesHeaderText]}>Bien</Text>
        <Text style={[actaStyles.bienesCellSerial, actaStyles.bienesHeaderText]}>Serial/es (elemento que permita individualizar el bien)</Text>
        <Text style={[actaStyles.bienesCellCantidad, actaStyles.bienesHeaderText]}>Cantidad</Text>
        <Text style={[actaStyles.bienesCellDescripcion, actaStyles.bienesHeaderText]}>Descripción</Text>
        <Text style={[actaStyles.bienesCellObs, actaStyles.bienesHeaderText]}>Observaciones</Text>
      </View>
    </View>
    {bienes.map((b, i) => (
      <View style={i === bienes.length - 1 ? actaStyles.bienesRowLast : actaStyles.bienesRow} key={i} wrap={false}>
        <Text style={[actaStyles.bienesCellNo, actaStyles.negrita]}>{i + 1}</Text>
        <Text style={actaStyles.bienesCellBien}>{b.bien}</Text>
        <Text style={actaStyles.bienesCellSerial}>N/A</Text>
        <Text style={actaStyles.bienesCellCantidad}>{b.cantidad}</Text>
        <Text style={actaStyles.bienesCellDescripcion}>{b.descripcion}</Text>
        <Text style={actaStyles.bienesCellObs}>{b.observaciones}</Text>
      </View>
    ))}
  </View>
);

const Clausulas = ({ items }) => (
  <View style={actaStyles.clausulasLista}>
    {items.map((texto, i) => (
      <View style={actaStyles.clausulaItem} key={i}>
        <Text style={actaStyles.clausulaLetra}>{String.fromCharCode(97 + i)})</Text>
        <Text style={actaStyles.clausulaTexto}>{texto}</Text>
      </View>
    ))}
  </View>
);

const Firmas = ({ recibe, usuarioEntrega, usuarioSupervisor }) => (
  <View style={actaStyles.firmasRow} wrap={false}>
    <View style={actaStyles.firmaBox}>
      <Text style={actaStyles.firmaLinea}>Recibe</Text>
      <Text style={actaStyles.firmaTexto}><Text style={actaStyles.negrita}>Nombre: </Text>{recibe.nombre}</Text>
      <Text style={actaStyles.firmaTexto}><Text style={actaStyles.negrita}>Cargo: </Text>{recibe.cargo}</Text>
      <Text style={actaStyles.firmaTexto}><Text style={actaStyles.negrita}>Cédula: </Text>{recibe.cedula}</Text>
    </View>
    <View style={actaStyles.firmaBox}>
      <Text style={actaStyles.firmaLinea}>Entrega: {usuarioEntrega || ""}</Text>
      <Text style={[actaStyles.firmaTexto, actaStyles.negrita]}>Equipo Técnico FAO</Text>
    </View>
    <View style={actaStyles.firmaBox}>
      <Text style={actaStyles.firmaLinea}>Entrega: {usuarioSupervisor || ""}</Text>
      <Text style={[actaStyles.firmaTexto, actaStyles.negrita]}>Supervisor Técnico Local FAO</Text>
    </View>
  </View>
);

// data: lo que se diligencia en el formulario / queda en la entrega.
//  comunes:      esOrganizacion, nombreProyecto, tipoActa, fechaEntrega, fechaDia, fechaMes, fechaAnio,
//                departamento, municipio, vereda, lugarEntrega, telefono, objetivo, bienes[],
//                usuarioEntrega, usuarioSupervisor
//  individual:   nombreBeneficiario, identificacion
//  organización: razonSocial, sigla, nit, representanteLegalNombre, representanteLegalCedula
export default function ActaEntregaPDF({ data }) {
  const {
    esOrganizacion, nombreProyecto, tipoActa, fechaEntrega, fechaDia, fechaMes, fechaAnio,
    departamento, municipio, vereda, lugarEntrega, telefono, objetivo, bienes = [],
    usuarioEntrega, usuarioSupervisor,
    nombreBeneficiario, identificacion,
    razonSocial, sigla, nit, representanteLegalNombre, representanteLegalCedula
  } = data;

  // Domicilio para el texto del acta de organizaciones. La fila "Lugar de
  // entrega" muestra solo lo digitado: si está vacío, queda vacía.
  const domicilio = lugarEntrega || vereda || municipio;
  const ubicacion = `${vereda ? `la vereda ${vereda}, ` : ""}municipio de ${municipio}, departamento de ${departamento}`;
  const organizacion = sigla || razonSocial;
  const repLegal = representanteLegalNombre || LINEA;
  const constancia = `a los ${fechaDia} días del mes de ${fechaMes} de ${fechaAnio}.`;

  return (
    <Document title={`Acta de entrega - ${esOrganizacion ? razonSocial : nombreBeneficiario}`}>
      <Page size="LETTER" style={actaStyles.page}>
        <Image src={logoArt} style={actaStyles.headerLogo} fixed />
        <Image src={bannerPie} style={actaStyles.footerBanner} fixed />

        <Text style={actaStyles.tituloConvenio}>{CONVENIO}</Text>
        <Text style={actaStyles.tituloProyecto}>{esOrganizacion ? nombreProyecto : NOMBRE_CONVENIO}</Text>
        <Text style={actaStyles.tituloActa}>
          ACTA DE ENTREGA DE BIENES – {esOrganizacion ? "ORGANIZACIONES" : "INDIVIDUAL"}
        </Text>

        <View style={actaStyles.infoTable}>
          <InfoRow label="Nombre del proyecto:" value={nombreProyecto} />
          <TipoEntregaRow tipoActa={tipoActa} />
          <InfoRow label="Fecha de entrega:" value={fechaEntrega} />
          <InfoRow label="Departamento:" value={departamento} />
          <InfoRow label="Municipio:" value={municipio} />
          <InfoRow label="Vereda:" value={vereda} />
          <InfoRow label="Lugar de entrega:" value={lugarEntrega} />
          {esOrganizacion ? (
            <>
              <InfoRow label="Razón social de la organización" value={razonSocial} />
              <InfoRow label="RUT" value={[nit, sigla].filter(Boolean).join(" - ")} />
              <InfoRow label="Nombres y apellidos representante legal de la organización:" value={representanteLegalNombre} />
            </>
          ) : (
            <>
              <InfoRow label="Nombres y apellidos beneficiario/a" value={nombreBeneficiario} />
              <InfoRow label="Identificación" value={identificacion} />
            </>
          )}
          <InfoRow label={esOrganizacion ? "Teléfono de contacto:" : "Teléfono de contacto"} value={telefono} last />
        </View>

        <Text style={actaStyles.seccionTitulo} minPresenceAhead={48}>OBJETIVO</Text>
        <Text style={actaStyles.parrafo}>{objetivo}</Text>

        <Text style={actaStyles.seccionTitulo} minPresenceAhead={48}>DESARROLLO</Text>
        {esOrganizacion ? (
          <Text style={actaStyles.parrafo}>
            {INTRO_FAO} a la organización productiva beneficiaria denominada {razonSocial}, con Número de
            Identificación Tributaria-NIT- (o documento de identidad): {nit || LINEA}, domicilio en {domicilio},
            representada legalmente por {repLegal}, ciudadano(a) colombiano(a) mayor de edad identificado(a) con
            cédula de ciudadanía número: {representanteLegalCedula || LINEA}, domiciliado(a) en {domicilio}.
          </Text>
        ) : (
          <Text style={actaStyles.parrafo}>
            {INTRO_FAO} a {nombreBeneficiario} con número de identificación {identificacion} del (los) bien(es)
            descrito(s) en esta acta.
          </Text>
        )}

        <Text style={actaStyles.seccionTitulo} minPresenceAhead={48}>
          PRIMERO. Descripción del bien entregado{esOrganizacion ? "" : "."}
        </Text>
        {esOrganizacion ? (
          <Text style={actaStyles.parrafo}>
            Con la firma de la presente acta y con la anuencia de la denominada {organizacion} se hace entrega
            formal en {municipio}, {departamento}{vereda ? `, vereda ${vereda},` : ""} al señor (a) {repLegal}{" "}
            de los bienes que a continuación se describen:
          </Text>
        ) : (
          <Text style={actaStyles.parrafo}>
            Con la firma de la presente acta se hace entrega formal en {ubicacion}, al señor (a){" "}
            {nombreBeneficiario}, de los bienes que a continuación se describen:
          </Text>
        )}

        <TablaBienes bienes={bienes} />

        <Text style={actaStyles.seccionTitulo} minPresenceAhead={48}>SEGUNDO. Recibo a satisfacción:</Text>
        {esOrganizacion ? (
          <Text style={actaStyles.parrafo}>
            Con la firma de la presente acta el (la) representante legal de la organización {organizacion} el (la)
            señor (a) {repLegal} manifiesta que recibe a conformidad y de acuerdo con las características técnicas y
            cantidades del plan de inversión acordado.
          </Text>
        ) : (
          <Text style={actaStyles.parrafo}>
            Con la firma de esta acta el (la) señor (a) {nombreBeneficiario}, manifiesta que recibe conforme a las
            características técnicas y cantidades del plan de inversión acordado.
          </Text>
        )}

        <Text style={actaStyles.seccionTitulo} minPresenceAhead={48}>TERCERO. Condiciones de la entrega:</Text>
        <Text style={actaStyles.parrafo}>
          {esOrganizacion ? `${organizacion}, se` : `El (la) señor (a) ${nombreBeneficiario} se`} compromete a
          cumplir con las siguientes condiciones:
        </Text>
        <Clausulas items={esOrganizacion ? CLAUSULAS_ORGANIZACION : CLAUSULAS_INDIVIDUAL} />

        {esOrganizacion && (
          <View>
            <Text style={actaStyles.seccionTitulo} minPresenceAhead={48}>PARÁGRAFO:</Text>
            <Text style={actaStyles.parrafo}>
              {organizacion} podrá hacer entrega en Comodato Gratuito a 10 años a los productores rurales del
              municipio de {municipio}, quienes deberán contar con una figura comunitaria aprobada por el cual deberá
              remitir un informe anual al consejo comunitario del uso y estado del bien mueble entregado, así mismo,
              dicha figura comunitaria de productores deberá asumir los costos de cuidado, reparación y mantenimiento
              del mismo. Sin perjuicio de las acciones de seguimiento que se definan por parte del beneficiario.
            </Text>
          </View>
        )}

        <Text style={actaStyles.seccionTitulo} minPresenceAhead={48}>CUARTO. Seguimiento al buen uso del bien:</Text>
        <Text style={actaStyles.parrafo}>{SEGUIMIENTO}</Text>

        <Text style={actaStyles.seccionTitulo} minPresenceAhead={48}>QUINTO. Eximente de responsabilidad</Text>
        <Text style={actaStyles.parrafo}>
          {esOrganizacion ? organizacion : `El (la) señor (a) ${nombreBeneficiario}`} {EXIMENTE}{" "}
          {esOrganizacion ? "entrega" : "donación"}.
        </Text>
        <Text style={actaStyles.parrafo}>
          {esOrganizacion
            ? `En constancia de lo anterior, se firma la presente acta ${constancia}`
            : `En constancia de lo anterior, se firma la presente acta en ${ubicacion} ${constancia}`}
        </Text>

        <Firmas
          recibe={esOrganizacion
            ? { nombre: representanteLegalNombre || "", cargo: "Representante legal", cedula: representanteLegalCedula || "" }
            : { nombre: nombreBeneficiario, cargo: "Participante", cedula: identificacion }}
          usuarioEntrega={usuarioEntrega}
          usuarioSupervisor={usuarioSupervisor}
        />
      </Page>
    </Document>
  );
}
